import React from "react";
import { FaNewspaper, FaPlus, FaRedo } from "react-icons/fa";

export default function ActualitesHeader({
  loading,
  demoMode,
  sectionId,
  onRefresh,
  onCreate,
}) {
  return (
    <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-white/10 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-primary via-indigo-500 to-emerald-500" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
          <div className="min-w-0">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Association active
            </p>

            <h1 className="mt-1 flex items-center gap-3 text-2xl font-bold text-slate-900 sm:text-[30px] dark:text-white">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-primary/10 text-primary">
                <FaNewspaper />
              </span>
              Actualités
            </h1>

            <p className="mt-2 max-w-4xl text-sm leading-6 text-slate-600 dark:text-slate-300">
              Créez, modifiez et publiez les actualités visibles sur la fiche de
              l’association sélectionnée.
            </p>

            {sectionId && (
              <p className="mt-2 text-xs font-bold uppercase tracking-[0.16em] text-slate-400">
                Section ID : {sectionId}
              </p>
            )}

            {demoMode && (
              <div className="mt-3 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm font-bold text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300">
                Mode démonstration actif : les actions sont désactivées.
              </div>
            )}
          </div>

          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={onCreate}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-primary px-4 py-2 text-sm font-bold text-white shadow-sm transition hover:opacity-90"
            >
              <FaPlus />
              Créer une actualité
            </button>

            <button
              type="button"
              onClick={onRefresh}
              disabled={loading}
              className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60 dark:border-white/10 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-white/10"
            >
              <FaRedo className={loading ? "animate-spin" : ""} />
              Actualiser
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}